import { render, staticRenderFns } from "./NotReceivedCampaignsTable.vue?vue&type=template&id=3efdc12c&scoped=true"
import script from "./NotReceivedCampaignsTable.vue?vue&type=script&lang=js"
export * from "./NotReceivedCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./NotReceivedCampaignsTable.vue?vue&type=style&index=0&id=3efdc12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efdc12c",
  null
  
)

export default component.exports